import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface TextContentDialogData {
  title: string;
  content: string;
}

@Component({
  selector: 'app-text-content-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <div [innerHTML]="data.content" style="white-space: pre-wrap; word-wrap: break-word; overflow-wrap: break-word; line-height: 1.6;"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="close()">OK</button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      max-height: 60vh;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 20px;
    }
  `]
})
export class TextContentDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TextContentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TextContentDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
